import React, { useEffect } from 'react'
import { useTracking } from 'react-tracking'

import BedroomCount from '../../atoms/ApartmentCard/BedroomCount'
import Price from '../../atoms/ApartmentCard/Price'
import Bedroom from '../../atoms/ApartmentCard/Bedroom'

export default ({ n, amount, ...props }) => {
  const tracking = useTracking()

  useEffect(() => {
    if (props.active) {
      tracking.trackEvent({
        label: n === 0 ? 'STUDIO' : `${n} BED`,
        event: 'Show Unit List',
        category: 'Engagement',
      })
    }
  }, [props.active, n, tracking])

  return (
    <Bedroom {...props}>
      <BedroomCount n={n} />
      <Price amount={amount} />
    </Bedroom>
  )
}
